import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api-client';

import { getSessionsQueryKey } from './list-sessions';

import type { SessionItem } from '../types';
import type { ApiResponse } from '@nohara-dxdev/oidc-core';

export const createSession = async (
  orgId: string,
  projectId: string,
  title: string,
): Promise<SessionItem> => {
  const { data } = await api.post<unknown, ApiResponse<SessionItem>>(
    `/orgs/${orgId}/projects/${projectId}/ai-agent/sessions`,
    { title },
  );

  return data;
};

export const useCreateSession = () => {
  const queryClient = useQueryClient();
  const { orgId, projectId } = useScopeIds('org', 'project');

  return useMutation({
    mutationKey: ['chat', 'sessions', 'create'],
    mutationFn: (title: string) => createSession(orgId, projectId, title),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: getSessionsQueryKey(orgId, projectId),
      });
    },
  });
};
